export function RootPending() {
  return (
    <div className="p-4">
      <p
        className="text-sm text-slate-600"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        Loading…
      </p>
    </div>
  )
}

